export const API_KEY = "AIzaSyDppIB1gDG_VDgxfG9yKFW3GmPfoaZ2ZP4";
